import React from 'react';
import Modal, { ModalSize } from '@ssg/common/Components/Modal';
import { useTranslation } from 'react-i18next';
import { SelectOption } from '@ssg/common/Helpers/Helpers';
import Dropdown from '@ssg/common/Components/Dropdown';
import { loader } from 'graphql.macro';
import { useMutation } from '@apollo/client';
import { UpdateCase, UpdateCaseVariables } from '../../GraphQL';
import Button from '@ssg/common/Components/Button';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { TrackSchema } from '../../Schemas/TrackSchema';

const UPDATE_CASE = loader('../../GraphQL/Cases/UpdateCase.gql');

interface IProps {
	open: boolean;
	close: () => void;
	currentTrack: number;
	caseId: string;
}

interface ITrack {
	track: number;
}

const ChangeTrack: React.FC<IProps> = ({ open, close, currentTrack, caseId }): React.ReactElement => {
	const { t } = useTranslation();

	const trackOptions: SelectOption[] = [
		{ label: 'Spor 0 - Telefonvagtsag', value: '0' },
		{ label: 'Spor 1', value: '1' },
		{ label: 'Spor 2 - Dagligdags drift', value: '2' },
		{ label: 'Spor 3', value: '3' },
		{ label: 'Spor 4 - Mangeskade / Akut', value: '4' },
		{ label: 'Spor 5 - Akut 2. Prioritet', value: '5' },
		{ label: 'Spor 6 - Afventer (f.eks. vand skal trække tilbage)', value: '6' },
		{ label: 'Spor 7 - Kun behov for tekniker', value: '7' },
		{ label: 'Spor 8 - Videregivet til underleverandør', value: '8' },
		{ label: 'Spor 9 - Ikke prioritetskunde', value: '9' },
		{ label: 'Spor 10', value: '10' },
	];

	const { handleSubmit, register } = useForm<ITrack>({
		resolver: yupResolver(TrackSchema),
		mode: 'all',
		reValidateMode: 'onChange',
	});

	const [updateCase, { loading: updateCaseSubmitting }] = useMutation<UpdateCase, UpdateCaseVariables>(UPDATE_CASE);

	const onSubmit = async (data: ITrack) => {
		try {
			await updateCase({
				variables: {
					id: caseId,
					track: data.track,
				},
			});
		} catch (e) {
			console.log(e);
		}
		close();
	};

	return (
		<Modal
			title="case.changeTrack"
			visible={open}
			close={close}
			size={ModalSize.SMALL}
			body={
				<form onSubmit={handleSubmit(onSubmit)} className="text-sm">
					<Dropdown title="case.track" name="track" innerRef={register} data={trackOptions} required defaultValue={currentTrack} disableSortLabelAlphabetically />

					<div className="mt-3">
						<Button submit success text="case.changeTrack" loading={updateCaseSubmitting} />
					</div>
				</form>
			}
		/>
	);
};

export default ChangeTrack;
